import { React, useState } from 'react'
import styled from 'styled-components'
import { FiEdit3 } from "react-icons/fi";
import { toast } from 'react-toastify';


function DeviceDescription({
    meter_id,
    description,
    onEditHandler,
}) {


    const [editOpen, setEditOpen] = useState(false);
    const [editClient, setEditClient] = useState('');
    const [editAddress, setEditAddress] = useState('');

    const openEditModal = () => {
        setEditClient(description?.client || '');
        setEditAddress(description?.address || '');
        setEditOpen(true)
    }


    return (
        <Container>
            <button className='edit-params' onClick={openEditModal}>
                <FiEdit3 />
            </button>
            <h1 className='meter-id'>{meter_id || 'Error con el dispositivo'}</h1>
            <p className='client'>{description?.client || 'Cliente no seteado'}</p>
            <p className='address'>{description?.address || 'Dirección no seteada'}</p>
            <p className='city'>{description?.city || 'Ciudad no seteada'}</p>

            {editOpen &&
                <div className="modal-backdrop" onClick={() => setEditOpen(false)}>
                    <div className="edit-modal" onClick={(event) => event.stopPropagation()}>
                        <div className="modal-heading">
                            <div>
                                <p className="eyebrow">CONFIGURACIÓN</p>
                                <h4>Editar datos del medidor</h4>
                            </div>
                        </div>
                        <label>Cliente<input maxLength={100} value={editClient} onChange={(e) => { setEditClient(e.target.value) }} /></label>
                        <label>Dirección<input maxLength={100} value={editAddress} onChange={(e) => { setEditAddress(e.target.value) }} /></label>
                        <div className="modal-actions">
                            <button className="cancel-button" onClick={() => setEditOpen(false)}>Cancelar</button>
                            <button className="save-button" onClick={()=>{
                                setEditOpen(false);
                                onEditHandler(editClient, editAddress);
                            }}>Guardar cambios</button>
                        </div>
                    </div>
                </div>}
        </Container>
    )
}


const Container = styled.div`
    display: grid;
    height: 80%;
    width: 100%;
    max-height: 80px;
    grid-template-columns: 150px 30px 1fr;
    grid-template-rows: repeat(4, 1fr);

    .client { grid-area: 2 / 1 / 3 / 4; }
    .address { grid-area: 3 / 1 / 4 / 4; }
    .city { grid-area: 4 / 1 / 5 / 4; }
    .edit-params { grid-area: 1 / 2 / 2 / 3; }

    .edit-params{
        display: grid;
        place-content: center;
        border: none;
        border-radius: 5px;
        font-size: 16px; 
        color: #34465f;
        transition: all .2s ease-in-out;
        &:hover{
            background: #dfe8f2; 
            color: #2c5daa;
            cursor: pointer;
        }
    }

    .meter-id{
        grid-area: 1 / 1 / 2 / 2;
        margin: 0;
        font-family: 'montserrat', sans-serif;
        font-size: 1.2rem;
    }

    p{
        margin: 0;
        font-family: 'montserrat', sans-serif;
        font-size: .9rem;
    }

    .modal-backdrop{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100vw;
        height: 100vh;
        background: #17263b55;
        display: grid;
        place-items: center;

        .edit-modal {
            width: min(410px, 100%);
            padding: 24px;
            border-radius: 14px;
            background: white;
            box-shadow: 0 18px 50px #24385255;


            .modal-heading {
                display: flex;
                justify-content: space-between;
                align-items: start;
                margin-bottom: 20px;

                h4 {
                    margin: 4px 0px 0px 0px;
                    font-size: 20px;
                }

                button {
                    border: 0;
                    background: transparent;
                    color: #71809a;
                }
            }

            label {
                display: grid;
                gap: 6px;
                margin-top: 14px;
                color: #52647d;
                font-size: 13px;
                font-weight: 700;
            }

            input {
                border: 1px solid #cbd7e5;
                border-radius: 7px;
                padding: 10px;
                color: #16243a;
                outline-color: #2c5daa;
            }

            .modal-actions {
                display: flex;
                justify-content: end;
                gap: 8px;
                margin-top: 24px;

                .cancel-button,
                .save-button {
                    border: 0;
                    border-radius: 7px;
                    padding: 9px 13px;
                    font-size: 13px;
                    cursor: pointer;
                    transition: all .2s ease-in-out;
                }

                .cancel-button {
                    color: #52647d;
                    background: #edf3fa;

                    &:hover{
                        background: #d8dde2ff
                    }
                }

                .save-button {
                    color: white;
                    background: #2c5daa;

                    &:hover{
                        background: #265197ff
                    }
                }

            }
        }
    }
    
`

export default DeviceDescription